// extracted by mini-css-extract-plugin
export default {"navigation":"PatientProfile_navigation__YhxhM","page":"PatientProfile_page__iF0oV"};